import { Button, DatePicker, Form, Input, Select, Space } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../../../app/store";
import DateIcon from "../../../../../assets/icons/DateIcon";
import SelectDropdownLgIcon from "../../../../../assets/icons/SelectDropdownLgIcon";
import { CheckedData } from "../../../../../components/common/sidebar/SidebarContent";
import CustomModal from "../../../../../components/ui/CustomModal";
import Loader from "../../../../../components/ui/Loader";
import {
  dateFormat,
  dbDateFormat,
  genderList,
} from "../../../../../constants/constants";
import { useActiveInvitedMutation } from "../../../../../features/emp-setting/employee/employeeApi";
import {
  useGetProtalAllDepartmentQuery,
  useGetProtalAllSubDepartmentQuery,
} from "../../../../../features/portal/settings/settingsApi";
import { useGetSingleUserQuery } from "../../../../../features/portal/user/userApi";
import useError from "../../../../../hooks/useError";
import { toast } from "../../../../../lib/toast";
import { ModalComponentProps } from "../../../../../types";
import {
  selectArrayOption,
  selectSearchOption,
  selectStringOption,
} from "../../../../../utils/utils";

export default function InvitedEmployeeActive({
  handleClose,
  ...rest
}: ModalComponentProps<CheckedData>) {
  const [form] = Form.useForm();
  const { viewId } = useParams();
  const [departmentId, setDepartmentId] = useState<number | undefined>(
    undefined
  );
  const { data, isLoading: isDetailsLoading } = useGetSingleUserQuery(
    viewId || "",
    {
      skip: !viewId,
    }
  );
  // const {
  //   data: payrollSettingData,
  //   isError: isPayrollSettingError,
  //   error: payrollSettingError,
  // } = useGetPayrollSettingQuery();
  const { user } = useAppSelector((state) => state.auth);
  const {
    data: departmentData,
    isError: isDepartmentError,
    error: departmentError,
  } = useGetProtalAllDepartmentQuery({
    params: {
      limit: 0,
      skip: 0,
      is_published: 1,
      company_id: user?.data?.company_id,
    },
  });
  const {
    data: designationData,
    isError: isDesignationError,
    error: designationError,
  } = useGetProtalAllSubDepartmentQuery(
    {
      params: {
        limit: 0,
        skip: 0,
        ...(departmentId
          ? { business_department_id: departmentId?.toString() || "" }
          : {}),
        status: true,
        company_id: user?.data?.company_id,
      },
    },
    {
      skip: !departmentId,
    }
  );

  const [activeInvited, { isLoading, isError, isSuccess, error }] =
    useActiveInvitedMutation();

  // error toast message
  useError(isDepartmentError, departmentError, "Get department fail");
  useError(isDesignationError, designationError, "Get designation fail");
  useError(isError, error, "Profile updated fail");
  // useError(
  //   isPayrollSettingError,
  //   payrollSettingError,
  //   "Gross salary configured data fail "
  // );

  const detailsData = data?.data;

  // const isShowModal =
  //   payrollSettingData?.data?.payroll_setting?.pay_components?.pay_schedule
  //     ?.is_enable;

  const onFinish = (values: any) => {
    const { join_date, department_id, mobile, ...rest } = values;
    const resolvedEmail = detailsData?.email || detailsData?.member?.profile?.email;
    const newData = {
      ...rest,
      // mobile: formatPhoneNumber(mobile),
      // department: departmentData?.data?.departments?.find(
      //   (department) => department?.id === department_id
      // )?.name,
      department_id,
      join_date: join_date.format(dbDateFormat),
      company_id: user?.data?.company_id,
      email: resolvedEmail,
      username: detailsData?.username,
    };

    activeInvited({
      body: newData,
      id: Number(viewId),
    });
  };

  useEffect(() => {
    if (Object.keys(data || {})) {
      form.setFieldsValue({
        name: detailsData?.name,
        // username: detailsData?.username,
        // mobile: detailsData?.mobile,
        gender: detailsData?.member?.profile?.gender,
        department_id: detailsData?.department?.id,
        sub_department_id: detailsData?.sub_department_id,
        join_date: detailsData?.join_date
          ? dayjs(detailsData?.join_date)
          : undefined,
      });

      setDepartmentId(detailsData?.department?.id);
    }
  }, [
    data,
    detailsData?.department?.id,
    detailsData?.join_date,
    detailsData?.member?.profile?.gender,
    detailsData?.name,
    detailsData?.sub_department_id,
    form,
  ]);

  useEffect(() => {
    if (isSuccess) {
      toast("success", "Co-worker activated successfully");
      handleClose();
    }
  }, [handleClose, isSuccess]);

  return (
    <CustomModal
      title="Fill Up the form to activate co-worker"
      {...rest}
      handleClose={handleClose}
      width={500}
      footer={null}
    >
      {isDetailsLoading ? (
        <Loader />
      ) : (
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
        >
          <Form.Item
            name="name"
            label="Name"
            className="mb-4"
            rules={[
              {
                required: true,
                message: "Please enter name",
              },
            ]}
          >
            <Input size="large" placeholder="Enter your name" />
          </Form.Item>{" "}
          {/* <Form.Item
            name="username"
            label="Username"
            className="mb-4"
            rules={[
              {
                required: true,
                message: "Please enter username",
              },
            ]}
          >
            <Input size="large" placeholder="Enter employee username" />
          </Form.Item> */}
          {/* <Form.Item
            name="mobile"
            label="Contact Number"
            className="mb-4"
            initialValue="+880"
            rules={[
              {
                validator: async (_: any, value: string) => {
                  if (!value) {
                    return Promise.reject(
                      new Error("Please enter phone number")
                    );
                  }
                  // if (!value) {
                  //   return Promise.resolve();
                  // }

                  const phoneRegex = /^(\+88)?(01[3-9])[0-9]{8}$/;
                  if (!phoneRegex.test(value)) {
                    return Promise.reject(
                      new Error("Please enter a valid Bangladeshi phone number")
                    );
                  }
                },
              },
            ]}
          >
            <Input prefix={<BDFlag />} size="large" placeholder="+8801" />
          </Form.Item> */}
          <Form.Item
            name="gender"
            label="Gender"
            className="mb-4"
            rules={[
              {
                required: true,
                message: "Please select a gender",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={selectStringOption(genderList)}
              suffixIcon={<SelectDropdownLgIcon />}
            />
          </Form.Item>
          <Form.Item
            name="department_id"
            label="Department"
            className="mb-4"
            rules={[
              {
                required: true,
                message: "Please select department",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={selectArrayOption(
                departmentData?.data?.departments || [],
                "name",
                "id"
              )}
              suffixIcon={<SelectDropdownLgIcon />}
              onChange={(val) => {
                setDepartmentId(val);
                form.setFieldsValue({ sub_department_id: undefined });
              }}
            />
          </Form.Item>
          <Form.Item
            name="sub_department_id"
            label="Designation"
            className="mb-4"
            rules={[
              {
                required: true,
                message: "Please select designation",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={selectArrayOption(
                designationData?.data?.data || [],
                "name",
                "id"
              )}
              suffixIcon={<SelectDropdownLgIcon />}
              disabled={!departmentId}
            />
          </Form.Item>
          {/* {isShowModal ? (
            <Form.Item
              name="gross_salary"
              label="Gross Salary"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please enter gross salary",
                },
                {
                  type: "number",
                  min: 0,
                  message: "Gross salary cannot negative",
                },
                {
                  type: "integer",
                  message: "Gross salary must be an integer",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%" }}
                placeholder="Enter gross salary"
              />
            </Form.Item>
          ) : null} */}
          <Form.Item
            name="join_date"
            label="Joining Date"
            className="mb-4"
            rules={[
              {
                required: true,
                message: "Please select joining date",
              },
            ]}
          >
            <DatePicker
              // defaultValue={dayjs(formatDate(), dateFormat)}
              format={dateFormat}
              suffixIcon={<DateIcon width={18} height={20} />}
              style={{ width: "100%" }}
              size="large"
              disabledDate={(current) => {
                const oneYearFromNow = dayjs().add(1, "year");
                return current && current > oneYearFromNow;
              }}
            />
          </Form.Item>
          <Space className="w-full mt-2" size={12}>
            <Button
              className="normal-dark-button modal-button"
              onClick={handleClose}
              size="middle"
            >
              Cancel
            </Button>
            <Button
              className="modal-button"
              type="primary"
              htmlType="submit"
              size="middle"
              loading={isLoading}
            >
              Activate co-worker
            </Button>
          </Space>
        </Form>
      )}
    </CustomModal>
  );
}
